module.exports = __webpack_public_path__ + "img/vignettes-asso_0008_belle-et-bien.aa8ff6d2.jpg";